const isRefetchRequired = (server: string, local: string) => {
  if (!local) return true;
  if (!server) return false;
  return new Date(server) > new Date(local);
};
const hasExternalLogin = (url?: string) => {
  const parsedUrl = new URL(url);
  if (parsedUrl) {
    return parsedUrl.searchParams.get("external_login") === "true";
  }
};

export { isRefetchRequired, hasExternalLogin };
